import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { Permission, showError } from '_metronic/helpers'
import { useAuth } from '../../../../auth'
import { getFormularioById, getFormularioOfEmpresaById } from './_requests'

/**
 * Formulário das telas de vínculos, vindo do `:id` da rota. Admin lê pelo endpoint da empresa;
 * os demais, pelo endpoint padrão. Em cache pela chave: cabeçalho e modal de vínculo compartilham
 * a mesma requisição.
 */
export const useFormularioAtual = () => {
  const { id } = useParams<{ id: string }>()
  const { currentUser } = useAuth()
  const isAdmin = currentUser?.grupo?.nome === Permission.Admin
  const formularioId = Number(id)

  return useQuery(
    ['formulario-atual', formularioId, isAdmin],
    () => (isAdmin ? getFormularioOfEmpresaById(formularioId) : getFormularioById(formularioId)),
    { enabled: Boolean(formularioId), refetchOnWindowFocus: false, onError: showError }
  )
}
